module.exports = __webpack_public_path__ + "img/matrix.68f46678.png";